import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts';
import moment from 'moment';
import 'moment/locale/zh-cn';
import request from './api/request';

// 注册权限指令
import './directives/permission';

Vue.use(ElementUI);

Vue.prototype.$echarts = echarts;
Vue.prototype.$moment = moment;
Vue.prototype.$http = request;

moment.locale('zh-cn');

Vue.config.productionTip = false;

// 请求浏览器通知权限
if ('Notification' in window && Notification.permission === 'default') {
  Notification.requestPermission();
}

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // 应用启动时统一初始化
    this.initApp();
  },
  methods: {
    initApp() {
      if (this.$store.getters.isLoggedIn) {
        // 先验证 token 是否有效，避免过期 token 发起多个 401 请求
        this.$store.dispatch('getUserInfo').then(() => {
          // Token 有效，执行需要认证的初始化
          this.$store.dispatch('startTokenRefreshTimer');
          this.$store.dispatch('initSocket');
          this.$store.dispatch('fetchFreezeStatus');
          this.$store.dispatch('fetchAccountingPeriod');
          // 每次启动都刷新系统配置（枚举选项以服务端为准，避免 localStorage 缓存过期）
          this.$store.dispatch('initSystemConfigs');
        }).catch(() => {
          // Token 无效，已由 request.js 自动处理（清除 token + 提示"登录已过期"）
          // 不再执行其他初始化，避免额外的 401
        });
      }
    }
  }
}).$mount('#app');
